import api from "./api";

export default class PlanoApi {
  static postPlanoName = async (obj: {}) => {
    const response = await api.post(`/Plano`, obj);
    return response.data;
  };

  static getPlanoList = async (page: any, RecordsPerPage: any, Search: any) => {
    const response = await api.get(
      `/Plano?Page=${page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}`
    );
    return response;
  };

  static getPlanoPerId = async (id: any) => {
    const response = await api.get(`/Plano/${id}`);
    return response.data;
  };

  static deletePlanoPerId = async (id: any) => {
    const response = await api.delete(`/Plano/${id}`);
    return response.data;
  };

  static updatePlanoPerId = async (id: any, obj: {}) => {
    const response = await api.put(`/Plano/${id}`, obj);
    return response.data;
  };

  static getRegisteredPlanoPerId = async (id: any) => {
    const response = await api.get(`/Cliente/${id}/plano/taxas`);
    return response.data;
  };

  static postPlano = async (id: any, obj: {}) => {
    const response = await api.post(`/Plano/${id}/taxas`, obj);
    return response.data;
  };

  static updateRegisteredPlanoPerId = async (id: any, obj: {}) => {
    const response = await api.put(`/Plano/${id}/taxas`, obj);
    return response.data;
  };
}
